export enum EAssistantPositionOptions {
    // MANUAL_INPUT = 'MANUAL_INPUT',
    FILE_INPUT = 'FILE_INPUT',
    INPUT_1C = 'INPUT_1C',
}
